import i18n from "../i18n";
import { moduleSettings } from "../stores/module-settings.store";
class LanguageSwitcherService {
  public listeners: Array<() => void> = [];

  public registerListener = (listener: () => void) => {
    this.listeners.push(listener);
  };

  public unregisterListeners = () => {
    this.listeners = [];
  };

  public callListeners = () => {
    this.listeners.forEach((listener) => {
      listener();
    });
  };

  public golLocaleFromSwitcher(localeFromSwitcher: string): string {
    if (localeFromSwitcher.toLowerCase() === "gb") {
      return "en";
    }
    if (localeFromSwitcher.toLowerCase() === "jp") {
      return "ja";
    }
    return localeFromSwitcher.toLowerCase();
  }

  public localeForCountryCode = (countryCode: string) => {
    if (["GB", "gb"].includes(countryCode)) {
      return "en";
    }
    if (["JP", "jp"].includes(countryCode)) {
      return "ja";
    }
    return countryCode.toLocaleLowerCase();
  };

  public countryCodeForLocale = (locale: string) => {
    if (locale === "en") {
      return "GB";
    }
    if (locale === "ja") {
      return "JP";
    }
    return locale.toUpperCase();
  };

  public switcherData = (supportedLngs: string[] | false): string[] => {
    var countries: string[] = [];
    const _supportedLngs = supportedLngs === false ? [] : supportedLngs;
    moduleSettings.getAvailableLocales().forEach((locale) => {
      if (_supportedLngs.includes(locale)) {
        var countryCode = this.countryCodeForLocale(locale);
        countries.push(countryCode);
      }
    });

    return countries;
  };

  public localeForMoment = () => {
    switch (i18n.language) {
      case "ee":
        return "et";
      case "ca":
        return "fr-ca";
      case "ch":
        return "fr-ch";
      case "se":
        return "sv";
      default:
        return i18n.language;
    }
  };
}

let languageSwitcherService: LanguageSwitcherService;

export const getLanguageSwitcherService = (): LanguageSwitcherService => {
  if (!languageSwitcherService) {
    languageSwitcherService = new LanguageSwitcherService();
  }
  return languageSwitcherService;
};
